export const conversitionCentsToDollars = (amount:number):number => {
  const quantityInDollars = amount * (100);
  return quantityInDollars;
}

